import request from '@/utils/request'

// 查询保险订单列表
export function listInsurance(query) {
  return request({
    url: '/insuranceOrder/insuranceOrder/list',
    method: 'get',
    params: query
  })
}

// 查询保险订单分页
export function pageInsurance(query) {
  return request({
    url: '/insuranceOrder/insuranceOrder/page',
    method: 'get',
    params: query
  })
}

// 查询保险订单详细
export function getInsurance(data) {
  return request({
    url: '/insuranceOrder/insuranceOrder/detail',
    method: 'get',
    params: data
  })
}

// 查询投保详情
export function getUnderwritingDetail(params) {
  return request({
    url: '/insuranceOrder/insuranceOrder/underwritingDetail',
    method: 'get',
    params
  })
}

// 新增保险订单
export function addInsurance(data) {
  return request({
    url: '/insuranceOrder/insuranceOrder/add',
    method: 'post',
    data: data
  })
}

// 修改保险订单
export function updateInsurance(data) {
  return request({
    url: '/insuranceOrder/insuranceOrder/edit',
    method: 'post',
    data: data
  })
}

// 删除保险订单
export function delInsurance(data) {
  return request({
    url: '/insuranceOrder/insuranceOrder/delete',
    method: 'post',
    data: data
  })
}

// 手动重试投保
export function manualRetryInsurance(data) {
  return request({
    url: '/insuranceOrder/insuranceOrder/manualRetry',
    method: 'post',
    data
  })
}

// 手动取消投保
export function manualCancelInsurance(data) {
  return request({
    url: '/insuranceOrder/insuranceOrder/manualCancel',
    method: 'post',
    data
  })
}

// 回传保单
export function uploadInsurancePolicy(data) {
  return request({
    url: '/insuranceOrder/insuranceOrder/uploadPolicy',
    method: 'post',
    data
  })
}

// 人工更新投保状态
export function updateInsuranceManualStatus(data) {
  return request({
    url: '/insuranceOrder/insuranceOrder/manualStatus',
    method: 'post',
    data
  })
}

// 投保下单（白鸽通道）：返回保司收银台地址，供财务完成保费支付
export function startInsureOrder(data) {
  return request({
    url: '/insuranceOrder/insuranceOrder/startInsureOrder',
    method: 'post',
    data
  })
}

// 投保下单（白鸽通道，按师傅）：单师傅一单，返回该师傅的收银台地址，供立即打开支付
// 收银台未过期时复用原收银台；已过期时后端自动换子流水号重新生成
export function startInsureOrderByPolicy(data) {
  return request({
    url: '/insuranceOrder/insuranceOrder/startInsureOrderByPolicy',
    method: 'post',
    data
  })
}

// 同步保单状态（白鸽侧）：主动向白鸽查询该师傅保单的真实状态并补偿到本地。
// 用于订单状态回调丢失的场景 —— 本地仍显示「待付款」而白鸽侧其实已支付，
// 此时若不先同步就打开旧收银台，会被白鸽提示「订单已支付」（E1 报错）。
// 财务点击「继续支付」前应先调用一次。
export function syncPolicyStatus(data) {
  return request({
    url: '/insuranceOrder/insuranceOrder/syncPolicyStatus',
    method: 'post',
    data
  })
}

/**
 * 白鸽保单人工核销：运营到白鸽后台核对真实付款流水后手动下终论，
 * 用于放行「待核对」状态的保单明细。
 * @param {Object} data { insuranceOrderId, policyId, conclusion: 1已支付并出单/0确认未支付, policyNo, policyFileUrl, remark }
 */
export function manualVerifyPolicyPay(data) {
  return request({
    url: '/insuranceOrder/insuranceOrder/manualVerifyPolicyPay',
    method: 'post',
    data
  })
}

/**
 * 白鸽保单付款台账-分页查询（可按保单明细ID查看某位师傅的完整付款流水）
 * @param {Object} data 见 AdminPayRecordPageParam
 */
export function payRecordPage(data) {
  return request({
    url: '/insuranceOrderPolicy/payRecord/page',
    method: 'post',
    data
  })
}

/**
 * 白鸽保单付款台账-导出Excel（返回 blob，供财务与白鸽线下核对）
 * @param {Object} data 查询条件，与分页查询一致
 */
export function payRecordExport(data) {
  return request({
    url: '/insuranceOrderPolicy/payRecord/export',
    method: 'post',
    data,
    responseType: 'blob',
    timeout: 120000
  })
}
